import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
export class StackedChart {
    /**
     * Takes a serie object and an idChart string or HTMLElement as parameters,
     * and then it sets the type, options, data properties.
     * The data variable calls the parent and prepare the data
     * @param {IChartSeries} serie - IChartSeries
     * @param {IAmchartBase} chart - Chart Object
     */
    constructor(serie, chart) {
        const { title, xAxeId, yAxeId, type, options, data, valueYShow, } = serie;
        this.title = title;
        this.xAxeId = xAxeId;
        this.yAxeId = yAxeId;
        this.valueYShow = valueYShow;
        this.chart = chart;
        this.type = type;
        this.options = options;
        this.data = chart.prepareSeriesData(data);
        // Initialize the chart axis
        this.setAxis();
    }
    /**
     * The function creates a series.
     */
    initSerie(enableZoom) {
        this.enableZoom = enableZoom;
        this.createSeries();
    }
    /**
     * This function sets the xAxisElement and yAxisElement properties of the class to the xAxis and
     * yAxis properties of the chart.
     */
    setAxis() {
        const { xAxis, yAxis } = this.chart;
        this.xAxisElement = xAxis;
        this.yAxisElement = yAxis;
    }
    /**
     * Create the series of chartBar
     */
    createSeries() {
        var _a, _b, _c;
        // Destructuring the colors from options
        const { fillColor, strokeColor } = this.getColors();
        const xAxisSerieResult = this.chart.chart
            .xAxes.values.filter((item) => item.name === this.xAxeId);
        const yAxisSerieResult = this.chart.chart
            .yAxes.values.filter((item) => item.name === this.yAxeId);
        let axisX = this.xAxisElement;
        if (xAxisSerieResult && xAxisSerieResult.length > 0) {
            axisX = xAxisSerieResult[0];
        }
        let axisY = this.yAxisElement;
        if (yAxisSerieResult && yAxisSerieResult.length > 0) {
            axisY = yAxisSerieResult[0];
        }
        // Creating a new column Stacked series and pushing it into the chart
        const objectSerie = {
            name: this.title,
            xAxis: axisX,
            yAxis: axisY,
            stacked: true,
            valueYField: 'value',
            valueXField: 'category',
            sequencedInterpolation: false,
            categoryXField: 'category',
            stroke: am5.color(strokeColor),
            fill: am5.color(fillColor), // Setting the fill color
        };
        if (this.valueYShow) {
            objectSerie.valueYShow = this.valueYShow;
        }
        const series = this.chart.chart.series.push(am5xy.ColumnSeries.new(this.chart.root, objectSerie));
        // If showCursor not informed initialize to true by default;
        this.options.showCursor = (_a = this.options.showCursor) !== null && _a !== void 0 ? _a : true;
        if (this.options.showCursor) {
            let cursor;
            if (this.options.enableTooltip) {
                const tooltip = this.chart.generateTooltip(this.options.tooltipFormat, this.yAxeId);
                if (this.options.stackedBarDisableZeroValueTooltip) {
                    tooltip.adapters.add('visible', (visible, target) => {
                        if (target.dataItem && target.dataItem.dataContext.value === 0) {
                            return false;
                        }
                        return visible;
                    });
                }
                series.set('tooltip', tooltip);
                cursor = this.chart.chart.set('cursor', am5xy.XYCursor.new(this.chart.root, {}));
                cursor.lineY.set('visible', false);
            }
            if (this.enableZoom) {
                cursor = this.chart.chart.set('cursor', am5xy.XYCursor.new(this.chart.root, {
                    behavior: 'zoomX',
                }));
                cursor.lineY.set('visible', false);
            }
        }
        if (this.chart.enableSerieAnimation && ((_b = this.options.bullets) === null || _b === void 0 ? void 0 : _b.bulletType) !== 'inner') {
            series.columns.template.events.on('pointerover', () => {
                this.chart.pointerOverEvent(this.chart.chart.series, series);
            });
            series.columns.template.events.on('pointerout', () => {
                this.chart.pointerOutEvent(this.chart.chart.series);
            });
        }
        // Setting the x-axis data
        this.xAxisElement.data.setAll(this.data);
        // Setting the series data
        series.data.setAll(this.data);
        // Animating the series appearance
        series.appear(1000);
        // Animating the chart appearance
        this.chart.chart.appear(1000, 100);
        // Saving the series element for later use
        this.seriesElement = series;
        if (((_c = this.options.bullets) === null || _c === void 0 ? void 0 : _c.bulletType) === 'inner') {
            series.bullets.push(() => am5.Bullet.new(this.chart.root, {
                sprite: am5.Label.new(this.chart.root, {
                    text: '{valueY}',
                    fill: this.chart.root.interfaceColors.get('alternativeText'),
                    centerY: am5.p50,
                    centerX: am5.p50,
                    populateText: true,
                }),
            }));
        }
    }
    /**
     * If the `fillColor` and `strokeColor` options are not defined,
     * then use the default values.
     */
    getColors() {
        const { fillColor, strokeColor } = this.options;
        const defaultStrokeColor = '#d1f2f5';
        const defaultFillColor = '#6771dc';
        return {
            fillColor: fillColor !== null && fillColor !== void 0 ? fillColor : defaultFillColor,
            strokeColor: strokeColor !== null && strokeColor !== void 0 ? strokeColor : defaultStrokeColor,
        };
    }
}
//# sourceMappingURL=stackedChart.js.map